import documentToolkit from "./documents/index.js";
import emailToolkit from "./email/index.js";
import localeToolkit from "./locales/index.js";

const toolkit = {
	document: documentToolkit,
	locale: localeToolkit,
	email: emailToolkit,
};

export default toolkit;
